import { render, staticRenderFns } from "./blockOd.vue?vue&type=template&id=f0c61fca&scoped=true"
import script from "./blockOd.vue?vue&type=script&lang=js"
export * from "./blockOd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c61fca",
  null
  
)

export default component.exports